import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import {
  ADVANCED_ACCOUNT_SETUP_STATUS_PROVIDER,
  AdvancedAccountSetupFeature,
  AdvancedAccountSetupTarget,
  AdvancedAccountStatus
} from "../types/advanced-account-setup.types";
import { AdvancedAccountSetupDialogService } from "./advanced-account-setup-dialog.service";

@Injectable({ providedIn: "root" })
export class AdvancedAccountSetupGateService {
  private readonly statusProvider = inject(ADVANCED_ACCOUNT_SETUP_STATUS_PROVIDER);
  private readonly dialogService = inject(AdvancedAccountSetupDialogService);

  checkReady(target: AdvancedAccountSetupTarget, feature: AdvancedAccountSetupFeature): Observable<boolean> {
    return this.statusProvider.getStatus(target).pipe(
      take(1),
      catchError(() => of(AdvancedAccountStatus.Ready)),
      map((status) => {
        if (status === AdvancedAccountStatus.Ready) {
          return true;
        }

        this.dialogService.open({ feature, target, status });

        return false;
      })
    );
  }

  open(target: AdvancedAccountSetupTarget, feature: AdvancedAccountSetupFeature): void {
    this.checkReady(target, feature).subscribe((ready) => {
      if (ready) {
        feature.open();
      }
    });
  }
}
